// External
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Internal
import { ValuesService } from '../../values/values.service';
import { DevicesService } from '../process/devices/devices.service';
import { NavigationService } from '../../navigation/navigation.service';

@Injectable({ providedIn: 'root' })

export class DevicesGuard {

    constructor(
        private readonly router: Router,
        private readonly valuesService: ValuesService,
        private readonly devicesService: DevicesService,
        private readonly navigationService: NavigationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean|UrlTree> {
        const urlProperties = this.navigationService.processUrl(route, state);
        const deviceCrc = urlProperties.urlParams['deviceCrc'];

        return new Observable( subscriber => {
            this.devicesService.listDevices().subscribe({
                next: () => {
                    if (deviceCrc) {
                        let device = this.devicesService.retrieveDeviceByCrc(deviceCrc);
                        if (!device) {
                            const _redirect = this.router.parseUrl( this.valuesService.centralPaths.devices.path );
                            subscriber.next(_redirect);
                            subscriber.complete();
                            return;
                        }
                        subscriber.next(true);
                        subscriber.complete();
                        return;
                    }
                    const _redirect = this.router.parseUrl( this.valuesService.centralPaths.devices.path );
                    subscriber.next(_redirect);
                    subscriber.complete();
                }
            });
        });
    }
}
